import { render, staticRenderFns } from "./EmailInvite.vue?vue&type=template&id=1632fa1e&scoped=true&"
import script from "./EmailInvite.vue?vue&type=script&lang=js&"
export * from "./EmailInvite.vue?vue&type=script&lang=js&"
import style0 from "./EmailInvite.vue?vue&type=style&index=0&id=1632fa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632fa1e",
  null
  
)

export default component.exports